// Undead creature prefabs: skeletons, zombie, wraith, lich, death knight,
// skeleton archer, banshee. Copied from adventure-craft.
import { box } from './creatures_shared.js';
import type { CharacterPrefab } from './types.js';

// ─── Skeletons ───────────────────────────────────────────────
export const skeleton: CharacterPrefab = {
  name: 'Skeleton',
  maxHp: 20,
  faction: 'undead',
  parts: [
    {
      name: 'head',
      voxels: [
        ...box(-2, 10, -1, 4, 4, 4, '#e8e8e8'),
        { x: -1, y: 12, z: 3, color: '#1a1a1a' },
        { x: 1, y: 12, z: 3, color: '#1a1a1a' },
        { x: 0, y: 10, z: 3, color: '#1a1a1a' },
      ],
    },
    {
      name: 'body',
      voxels: [
        ...box(-2, 5, 0, 5, 4, 1, '#d4d4d4'),
        { x: 0, y: 9, z: 0, color: '#d4d4d4' },
        { x: 0, y: 8, z: 0, color: '#d4d4d4' },
        { x: 0, y: 7, z: 0, color: '#d4d4d4' },
        { x: 0, y: 6, z: 0, color: '#d4d4d4' },
        { x: 0, y: 5, z: 0, color: '#d4d4d4' },
      ],
    },
    { name: 'left_arm', voxels: box(-3, 6, 0, 1, 4, 1, '#d4d4d4') },
    { name: 'right_arm', voxels: box(3, 6, 0, 1, 4, 1, '#d4d4d4') },
    { name: 'left_leg', voxels: box(-1, 0, 0, 1, 5, 1, '#d4d4d4') },
    { name: 'right_leg', voxels: box(1, 0, 0, 1, 5, 1, '#d4d4d4') },
  ],
};

export const zombie: CharacterPrefab = {
  name: 'Zombie',
  maxHp: 30,
  faction: 'undead',
  parts: [
    {
      name: 'head',
      voxels: [
        ...box(-2, 10, -1, 4, 4, 4, '#5a7a5a'),
        { x: -1, y: 12, z: 3, color: '#1a1a1a' },
        { x: 1, y: 12, z: 3, color: '#1a1a1a' },
        { x: 0, y: 11, z: 3, color: '#3d5c3d' },
      ],
    },
    {
      name: 'body',
      voxels: [...box(-2, 5, 0, 4, 5, 2, '#4a6a4a'), ...box(-2, 5, 0, 4, 2, 2, '#3d5c3d')],
    },
    { name: 'left_arm', voxels: box(-4, 6, 0, 2, 5, 2, '#5a7a5a') },
    { name: 'right_arm', voxels: box(2, 6, 0, 2, 5, 2, '#5a7a5a') },
    { name: 'left_leg', voxels: box(-2, 0, 0, 2, 5, 2, '#3a4a6a') },
    { name: 'right_leg', voxels: box(0, 0, 0, 2, 5, 2, '#3a4a6a') },
  ],
};

export const wraith: CharacterPrefab = {
  name: 'Wraith',
  maxHp: 30,
  faction: 'undead',
  canFly: true,
  parts: [
    {
      name: 'head',
      voxels: [
        ...box(-2, 12, -1, 4, 4, 4, '#1a1a3a'),
        { x: -1, y: 14, z: 3, color: '#4444ff' },
        { x: 1, y: 14, z: 3, color: '#4444ff' },
      ],
    },
    {
      name: 'body',
      voxels: [...box(-2, 6, 0, 4, 6, 2, '#0a0a2a'), ...box(-2, 4, -1, 4, 2, 0, '#0a0a2a')],
    },
    { name: 'left_arm', voxels: box(-4, 8, 0, 2, 4, 2, '#1a1a3a') },
    { name: 'right_arm', voxels: box(2, 8, 0, 2, 4, 2, '#1a1a3a') },
    { name: 'left_leg', voxels: box(-2, 2, 0, 2, 2, 2, '#0a0a2a') },
    { name: 'right_leg', voxels: box(0, 2, 0, 2, 2, 2, '#0a0a2a') },
  ],
};

export const lich: CharacterPrefab = {
  name: 'Lich',
  maxHp: 200,
  faction: 'undead',
  parts: [
    {
      name: 'head',
      voxels: [
        ...box(-2, 16, -2, 4, 4, 4, '#e8e8e8'),
        ...box(-3, 20, -2, 6, 2, 5, '#ffd700'),
        { x: -1, y: 18, z: 3, color: '#8b0000' },
        { x: 1, y: 18, z: 3, color: '#8b0000' },
      ],
    },
    {
      name: 'body',
      voxels: [...box(-4, 6, -2, 8, 10, 4, '#1a1a1a'), ...box(-3, 8, -3, 6, 8, 1, '#2e1065')],
    },
    {
      name: 'left_arm',
      voxels: [...box(-6, 12, 0, 2, 8, 2, '#1a1a1a'), ...box(-6, 10, 0, 2, 6, 2, '#e8e8e8')],
    },
    {
      name: 'right_arm',
      voxels: [
        ...box(4, 12, 0, 2, 8, 2, '#1a1a1a'),
        ...box(4, 10, 0, 2, 6, 2, '#e8e8e8'),
        ...box(5, 6, -2, 1, 14, 1, '#5c3317'),
        { x: 5, y: 20, z: -2, color: '#22c55e' },
      ],
    },
    { name: 'left_leg', voxels: box(-3, 0, 0, 3, 6, 3, '#1a1a1a') },
    { name: 'right_leg', voxels: box(0, 0, 0, 3, 6, 3, '#1a1a1a') },
  ],
};

export const deathKnight: CharacterPrefab = {
  name: 'Death Knight',
  maxHp: 180,
  faction: 'undead',
  parts: [
    {
      name: 'head',
      voxels: [
        ...box(-2, 14, -1, 4, 4, 4, '#1a1a1a'),
        { x: -1, y: 16, z: 3, color: '#4488ff' },
        { x: 1, y: 16, z: 3, color: '#4488ff' },
        ...box(-1, 18, 0, 2, 2, 2, '#2a2a2a'),
      ],
    },
    {
      name: 'body',
      voxels: [
        ...box(-3, 6, -1, 6, 8, 4, '#0a0a0a'),
        ...box(-2, 8, 3, 4, 4, 1, '#e8e8e8'),
        { x: 0, y: 10, z: 3, color: '#4488ff' },
      ],
    },
    { name: 'left_arm', voxels: box(-5, 8, 0, 2, 6, 2, '#1a1a1a') },
    {
      name: 'right_arm',
      voxels: [
        ...box(3, 8, 0, 2, 6, 2, '#1a1a1a'),
        ...box(4, 6, -2, 1, 10, 1, '#4488ff'),
        { x: 4, y: 16, z: -2, color: '#88ccff' },
      ],
    },
    { name: 'left_leg', voxels: box(-2, 0, 0, 2, 6, 2, '#0a0a0a') },
    { name: 'right_leg', voxels: box(0, 0, 0, 2, 6, 2, '#0a0a0a') },
  ],
};

export const skeletonArcher: CharacterPrefab = {
  name: 'Skeleton Archer',
  maxHp: 25,
  faction: 'undead',
  parts: [
    {
      name: 'head',
      voxels: [
        ...box(-2, 10, -1, 4, 4, 4, '#e8e8e8'),
        { x: -1, y: 12, z: 3, color: '#ff4444' },
        { x: 1, y: 12, z: 3, color: '#ff4444' },
      ],
    },
    {
      name: 'body',
      voxels: [
        ...box(-2, 5, 0, 5, 4, 1, '#d4d4d4'),
        { x: 0, y: 9, z: 0, color: '#d4d4d4' },
        { x: 0, y: 8, z: 0, color: '#d4d4d4' },
        { x: 0, y: 7, z: 0, color: '#d4d4d4' },
        { x: 0, y: 6, z: 0, color: '#d4d4d4' },
        { x: 0, y: 5, z: 0, color: '#d4d4d4' },
      ],
    },
    {
      name: 'left_arm',
      voxels: [...box(-3, 8, 0, 1, 3, 1, '#d4d4d4'), ...box(-5, 7, -1, 4, 1, 1, '#8b4513')],
    },
    { name: 'right_arm', voxels: box(3, 6, 0, 1, 4, 1, '#d4d4d4') },
    { name: 'left_leg', voxels: box(-1, 0, 0, 1, 5, 1, '#d4d4d4') },
    { name: 'right_leg', voxels: box(1, 0, 0, 1, 5, 1, '#d4d4d4') },
  ],
};

export const banshee: CharacterPrefab = {
  name: 'Banshee',
  maxHp: 60,
  faction: 'undead',
  canFly: true,
  parts: [
    {
      name: 'head',
      voxels: [
        ...box(-2, 14, -1, 4, 4, 4, '#c0c0c0'),
        { x: -1, y: 16, z: 3, color: '#ffffff' },
        { x: 1, y: 16, z: 3, color: '#ffffff' },
        { x: 0, y: 15, z: 3, color: '#000000' },
      ],
    },
    {
      name: 'body',
      voxels: [...box(-3, 6, 0, 6, 8, 2, '#d0d0d0'), ...box(-3, 4, -1, 6, 2, 0, '#d0d0d0')],
    },
    { name: 'left_arm', voxels: box(-5, 8, 0, 2, 6, 2, '#c0c0c0') },
    { name: 'right_arm', voxels: box(3, 8, 0, 2, 6, 2, '#c0c0c0') },
    { name: 'left_leg', voxels: box(-2, 2, 0, 2, 2, 2, '#d0d0d0') },
    { name: 'right_leg', voxels: box(0, 2, 0, 2, 2, 2, '#d0d0d0') },
  ],
};
